import React, {useEffect} from "react";
import {useDispatch, useSelector} from 'react-redux';
import './ListItem.scss';

import avatar from "../../assets/images/user_avatar.png";
import {toggleModal} from "../../store/actions/toggleModalActions";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    }
};

const ListItem = props => {
    const {t} = useSelector(selector);
    const {
        item,
        index,
        page,
        selectItemMethod,
        onSelectModalName,
        columns,
        columnsWidths,
        columnWidth,
        avatarColumn,
        avatarUrl,
        measurementTimeColumn,
        booleanColumn,
        invertedBooleanColumn,
        referenceColumn,
        referenceField,
        referenceData,
        selected,
        picker,
        deleteColumn,
        editColumn,
        editMethod,
        deleteMethod,
        rainSensorColumn,
        wetLeafSensorColumn,
        alarmLowColumn,
        warningLowColumn,
        alarmHighColumn,
        warningHighColumn,
        checkboxColumn,
        handleSelectSensors,
        editAlertColumn,
        selectedSensors,
        inSensorColumn,
        outSensorColumn,
        dateColumn,
        virtualStationColumn,
        selectableColumn,
        isItemSelected,
        onItemSelectionChange
    } = props;
    const dispatch = useDispatch();

    const handleItemClick = () => {
        if (selectItemMethod) {
            if (picker) {
                selectItemMethod(item)
            } else {
                dispatch(selectItemMethod(item, page));
            }
        }
        if (onSelectModalName) {
            if (picker) {
                onSelectModalName()
            } else {
                dispatch(toggleModal(true, onSelectModalName));
            }

        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('pl-PL'); // => "14.07.2025"
    };

    const formatUtcToLocalDateTime = (dateString) => {
        if (!dateString) return '';

        const hasTimezoneInfo = /([zZ]|[+-]\d{2}:\d{2})$/.test(dateString);
        const normalizedDateString = hasTimezoneInfo ? dateString : `${dateString}Z`;
        const date = new Date(normalizedDateString);

        if (Number.isNaN(date.getTime())) {
            return dateString;
        }

        const pad = (value) => value.toString().padStart(2, '0');

        return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
    };

    const getFieldValue = (column, index) => {

        if (index === Number(selectableColumn) - 1) {
            return (
                <label className='checkboxContainer' onClick={event => event.stopPropagation()}>
                    <input
                        type='checkbox'
                        checked={isItemSelected(item)}
                        onChange={() => onItemSelectionChange(item)}
                    />
                    <span className='checkMark'/>
                </label>
            );
        }

        if (index === Number(booleanColumn) - 1) {
            if (item[column]) {

                return <span className='material-icons iconTrue'>check_circle</span>
            } else {
                return <span style={item?.measurements && item?.measurements.length === 0 ? {color: '#ddd'} : null} className='material-icons iconFalse'>cancel</span>
            }
        }

        if (index === Number(virtualStationColumn) - 1) {
            return item?.virtual
                ? (
                    <div className='virtualStationIconWrapper'>
                        <span className='material-icons virtualStationIcon' title={t.gettext('Virtual station')}>cloud_done</span>
                    </div>
                )
                : '';
        }

        if (index === Number(invertedBooleanColumn) - 1) {
            if (!item[column]) {
                return <span className='material-icons iconTrue'>check_circle</span>
            } else {
                return <span className='material-icons iconFalse'>cancel</span>
            }
        }

        if (index === Number(measurementTimeColumn) - 1) {
            if (item[column].length) {
                return formatUtcToLocalDateTime(item[column][item[column].length - 1].dateTimeCreated);
            } else {
                return t.gettext('No measurements');
            }
        }

        if (index === Number(deleteColumn) - 1) {
            return <i onClick={deleteMethod} id={item.id}
                      className='material-icons actionIcon deleteIcon deleteIcon--inactive'>
                delete
            </i>
        }

        if (index === Number(editColumn) - 1) {
            return <i onClick={editMethod} id={item.id}
                      className='material-icons actionIcon editIcon deleteIcon--inactive'>
                edit
            </i>
        }

        if (index === Number(dateColumn) - 1) {
            return formatDate(item?.createdAt);
        }

        if (index === Number(editAlertColumn) - 1) {
            if(item.editable) {
                return <i onClick={editMethod} id={item.id}
                          className='material-icons actionIcon editIcon deleteIcon--inactive'>
                    edit
                </i>
            }
        }

        if (index === Number(referenceColumn) - 1) {
            return referenceData.find(x => x.id === Number(item[column]))?.[referenceField];
        }

        if (index === Number(rainSensorColumn) - 1) {
            if (item.rainSensor && item.rainSensor.name) {
                return item.rainSensor.name
            }
        }

        if (index === Number(wetLeafSensorColumn) - 1) {
            if (item.wetLeafSensor && item.wetLeafSensor.name) {
                return item.wetLeafSensor.name
            }
        }

        if (index === Number(inSensorColumn) - 1) {
            if (item.inWaterCountSensor && item.inWaterCountSensor.name) {
                return item.inWaterCountSensor.name
            }
        }

        if (index === Number(outSensorColumn) - 1) {
            if (item.outWaterCountSensor && item.outWaterCountSensor.name) {
                return item.outWaterCountSensor.name
            }
        }

        if (index === Number(alarmLowColumn) - 1) {
            if (item.thresholds) {
                const warning = item.thresholds.find(x => x.warningType === 'ALARM_LOW')
                if (warning) {
                    if (warning.value === 0) {
                        return '0';
                    } else {
                        return warning.value.toString();
                    }
                } else {
                    return '-';
                }
            }
        }

        if (index === Number(warningLowColumn) - 1) {
            if (item.thresholds) {
                const warning = item.thresholds.find(x => x.warningType === 'WARNING_LOW')
                if (warning) {
                    if (warning.value === 0) {
                        return '0';
                    } else {
                        return warning.value.toString(); // Convert the value to a string
                    }
                } else {
                    return '-';
                }
            }
        }

        if (index === Number(alarmHighColumn) - 1) {
            if (item.thresholds) {
                const warning = item.thresholds.find(x => x.warningType === 'ALARM_HIGH')
                if (warning) {
                    if (warning.value === 0) {
                        return '0';
                    } else {
                        return warning.value.toString(); // Convert the value to a string
                    }
                } else {
                    return '-';
                }
            }
        }

        if (index === Number(warningHighColumn) - 1) {
            if (item.thresholds) {
                const warning = item.thresholds.find(x => x.warningType === 'WARNING_HIGH')
                if (warning) {
                    if (warning.value === 0) {
                        return '0';
                    } else {
                        return warning.value.toString(); // Convert the value to a string
                    }
                } else {
                    return '-';
                }
            }
        }

        return item[column]
    };

    const getClass = () => {
        if (warningHighColumn) {
            return `listItem ${selected?.ruleID === item.ruleID ? 'listItem--selected' : ''}`
        } else if(selected && selected.id) {
            return `listItem ${selected?.id === item.id ? 'listItem--selected' : ''}`
        } else {
            return `listItem`
        }
    }

    if (checkboxColumn) {
        return (
            <li
                className={getClass()}
                key={index}
                // onClick={() => handleSelectSensors(item)}
            >
                <div className="checkboxWrapper" >
                    <label className='checkboxContainer'  >
                        <input type="checkbox"
                               // disabled
                            // checked
                            // value={selectedSensors.find(x => x === item.id)}
                            onChange={() => handleSelectSensors(item)}
                            //    checked={selectedSensors.find(x => x === item.id)}
                        />
                        <span className="checkMark"/>
                    </label>
                </div>
                {columns.map((column, index) => (
                    <div className='listItemCell' key={index}
                         style={{width: !columnWidth ? columnsWidths[index] : columnWidth}}>
                        {avatarColumn === index + 1 &&
                            <div className='avatarContainer'>
                                <img className='avatar' src={item[avatarUrl] || avatar} alt='Avatar'/>
                            </div>
                        }
                        {getFieldValue(column, index)}
                    </div>
                ))}
            </li>
        )
    } else {
        return (
            <li
                className={getClass()}
                key={index}
                onClick={handleItemClick}
            >
                {columns.map((column, index) => (
                    <div className='listItemCell' key={index} style={{width: !columnWidth ? columnsWidths[index] : columnWidth}}>
                        {avatarColumn === index + 1 &&
                            <div className='avatarContainer'>
                                <img className='avatar' src={item[avatarUrl] || avatar} alt='Avatar'/>
                            </div>
                        }
                        {getFieldValue(column, index)}
                    </div>
                ))}
            </li>
        )
    }



}

export default ListItem;
